import { useEffect, useState } from 'react';
import { InfoTwoTone as InfoIcon } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { Grid } from '@mui/system'
import clsx from 'clsx';
import { ENTER_DATA } from 'common/constants/inputs';
import { useStore } from 'common/store';
import CompGroupLabel from 'components/FeaturedSpreadsheet/components/CompGroupLabel';
import RowLabelTooltip from 'components/RowLabelTooltip/RowLabelTooltip';
import { useRevealEllipsisInTooltip } from 'services/hooks';
import { CompGroupRowHeaderProps } from './CompGroupRowHeader.props';
import { compGroupRowHeaderClasses, CompGroupRowHeaderRoot } from './CompGroupRowHeader.styles';


const CompGroupRowHeader = ({
  allowShowCompanyDialog,
  cell,
  companyDialogComponent,
  comparisonData,
  compGroupData,
  value,
  currency,
  showPricingDateWarning,
}: CompGroupRowHeaderProps) => {
  const [isHovering, setIsHovering] = useState(false);
  const [openCompanyInfoDialog, setOpenCompanyInfoDialog] = useState(false);
  const { tooltipRef, width } = useRevealEllipsisInTooltip();
  const [
    {
      companyInfo: { financials_currency: financialsCurrency },
    },
  ] = useStore();
  const CompanyDialogComponent = companyDialogComponent;

  const handleClick = () => {
    setOpenCompanyInfoDialog(true);
  };

  useEffect(() => {
    if (!openCompanyInfoDialog) {
      setIsHovering(false);
    }
  }, [openCompanyInfoDialog]);

  const titleValue = (value || cell?.value || ENTER_DATA) as string;
  const VIEW_COMPANY_INFO = (companyName: string) => `View ${companyName} info`;
  const PRICING_DATE_WARNING = 'Pricing data is more than a week old compared to the market date';

  return (
    <CompGroupRowHeaderRoot onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      {/* This is ignored because the ref is not part of the BoxProps. It will have support in the most recent version of material-ui */}
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore:next-line */}
      <Box ref={tooltipRef} className={compGroupRowHeaderClasses.fullCell} display="flex" justifyContent="flex-start" alignItems="center">
        <div className={compGroupRowHeaderClasses.contentValue}>
          <Grid className={compGroupRowHeaderClasses.textContainer}>
            {compGroupData && <CompGroupLabel compGroupData={compGroupData} setCompanyInfoHovering={setIsHovering} />}
            {showPricingDateWarning ? (
              <Tooltip placement="bottom-start" title={PRICING_DATE_WARNING} arrow>
                <span className={compGroupRowHeaderClasses.warningText}>
                  <RowLabelTooltip title={titleValue} containerWidth={width}>
                    <span>{titleValue}</span>
                  </RowLabelTooltip>
                </span>
              </Tooltip>
            ) : (
              <RowLabelTooltip title={titleValue} containerWidth={width}>
                <span>{titleValue}</span>
              </RowLabelTooltip>
            )}
          </Grid>
          {allowShowCompanyDialog && companyDialogComponent && (
            <>
              <Grid className={clsx(compGroupRowHeaderClasses.iconContainer, { active: isHovering })} id="company-info-icon-container">
                <Tooltip placement="top-end" title={VIEW_COMPANY_INFO(titleValue)} arrow>
                  <InfoIcon className={compGroupRowHeaderClasses.icon} onClick={handleClick} />
                </Tooltip>
              </Grid>
              <CompanyDialogComponent
                data={comparisonData}
                financialsCurrency={currency ?? financialsCurrency}
                openDialog={openCompanyInfoDialog}
                setOpenDialog={setOpenCompanyInfoDialog}
              />
            </>
          )}
        </div>
      </Box>
    </CompGroupRowHeaderRoot>
  );
};

export default CompGroupRowHeader;
